<div class="container">
    <mat-dialog-title class="title-block">
        <h2>EXPORT PRO(S)</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <div *ngIf="partner" class="partner-container">
        <div class="partner-block">
            <span id="partner-label">PARTNER:</span>

            <span id="partner-name">
                {{partner.name}}
            </span>
        </div>
    </div>

    <mat-dialog-content class="content-block">

        <div class="content-container">
            <app-loader *ngIf="exporting" color="#50e3c2"></app-loader>

            <div class="content">
                <mat-grid-list cols="2" rowHeight="2:1" class="pro-list" *ngFor="let pro of pros; let i = index">

                    <mat-grid-tile class="pro-details">
                        {{pro.type}} 
                        <app-bullet-icon></app-bullet-icon>
                        {{pro.year}}
                        <app-bullet-icon></app-bullet-icon>
                        {{pro.quarter}}
                    </mat-grid-tile>

                    <mat-grid-tile class="checkbox-field" >
                        <section class="" [ngClass]="{'selected-checkbox' : pro.pdfSelected}">
                            <mat-checkbox [(ngModel)]="pro.pdfSelected"></mat-checkbox>
                            <mat-label>PDF</mat-label>
                        </section>

                        <section class="" [ngClass]="{'selected-checkbox' : pro.csvSelected}">
                            <mat-checkbox [(ngModel)]="pro.csvSelected"></mat-checkbox>
                            <mat-label>CSV</mat-label>
                        </section>

                        <section class="" [ngClass]="{'selected-checkbox' : pro.xlsxSelected}">
                            <mat-checkbox [(ngModel)]="pro.xlsxSelected"></mat-checkbox>
                            <mat-label>XLSX</mat-label>
                        </section>
                    </mat-grid-tile>

                </mat-grid-list>
            </div>

        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="export-btn" mat-button (click)="exportPros()" [disabled]="exporting">EXPORT</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>